export const ProductionPlanMeal = (json: IProductionPlanMeal): IProductionPlanMealModel => {
	const { meal_id, variant_id, date, remaining_quantity, created_at, updated_at } = json

	return {
		date,
		mealID: meal_id,
		variantID: variant_id,
		remainingQuantity: remaining_quantity,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}
